import Cookies from 'js-cookie';
import Apis from '@/request/apis';

let tool = {
    vm:null,

    install(Vue, vm) {
        Vue.prototype.$tool = tool;
        this.vm = vm
    },

    //获取cookie
    getCookie(name) {
        return Cookies.get(name);
    },

    //写cookie
    setCookie(name, value, days) {
        let Days = days || 30;
        Cookies.set(name, value, {expires: Days, domain:'.dellemc-solution.com'})
    },

    //删除cookie
    delCookie(key) {
        Cookies.remove(key, {domain:'.dellemc-solution.com'})
    },

    // 设置登录cookie
    setLoginCookie(userInfo) {
        this.setCookie('smarketMember_498', JSON.stringify({
            session: userInfo.session,
            memberId: userInfo.memberId,
            email: userInfo.email
        }), 5);
        this.setCookie('OCSESSID', userInfo.OCSESSID, 5);
        gio('track', 'loginSuccess',
            {
                'user_Id': userInfo.memberId,  // memberId
                'phoneNumber': userInfo.mobile, //登录手机号
                'loginType': '短信' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
            }
        )
        this.delLS('userInfo');
        this.setGioUser();
    },

    // 设置用户变量
    async setGioUser(){
        let loginInfo = this.isLogin();
        let globalUserId = this.getGlobalUserId();
        let userId = loginInfo? loginInfo.memberId: globalUserId;
        gio('visitor.set', {'cookie_original': userId, 'cookieID':globalUserId}); //GIO 访问用户变量上传

        if(loginInfo){
            let userInfo = await this.getUserInfo();
            gio('setUserId', userId);
            var gioParams = {
                area_ppl: userInfo?.province?.toString() || '',                             //省份城市
                companyName_ppl: userInfo?.enterprise_name || '',                           //公司名称
                companyScale_ppl: userInfo?.employeesNumber?.toString() || '',              //公司规模
                email_ppl: userInfo?.email || '',                                           //邮箱
                industry_ppl: userInfo?.industry?.toString() || '',                         //行业
                phone_ppl: userInfo?.mobile || '',                                          //手机
                userName_ppl: userInfo?.name || '',                                         //姓名
                userRole_ppl: userInfo?.position?.toString()  || ''                         //职位
            };
            gio('people.set',gioParams);
        }
    },

    // 获取用户行信息 如果update 为true 则强制更新
    async getUserInfo(update) {

        let userInfoCache = this.getLS('userInfo', 1);
        if(userInfoCache && !update){
            return userInfoCache
        }
        let userInfo = await Apis.getUserInfo(this.getGlobalUserId(), this.isLogin()?.session);
        if(userInfo?.body?.result === 0) {
            let returnArr = {}
            userInfo.body.content.forEach(item=>{
                returnArr[item.key] = item.value
            })
            this.setLS('userInfo', returnArr, 1)
            return returnArr
        }
        console.log('获取用户信息失败')
        return false;
    },

    //写入SessionStorage
    setSS(name, value, isJson) {
        if (isJson) {
            sessionStorage.setItem(name, JSON.stringify(value));
        } else {
            sessionStorage.setItem(name, value);
        }
    },

    getSS(name, isJson) {
        if (isJson) {
            return JSON.parse(sessionStorage.getItem(name));
        } else {
            return sessionStorage.getItem(name);
        }
    },

    //写入localStorage
    setLS(name, value, isJson) {
        if (isJson) {
            localStorage.setItem(name, JSON.stringify(value));
        } else {
            localStorage.setItem(name, value);
        }
    },

    getLS(name, isJson) {
        if (isJson) {
            return JSON.parse(localStorage.getItem(name));
        } else {
            return localStorage.getItem(name);
        }
    },

    delLS(name) {
        localStorage.removeItem(name);
    },

    //获取地址栏参数
    getUrlPara(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r !== null) {
            return decodeURIComponent(r[2]);
        }
        return this.getHashPara(name) || null;
    },

    getHashParameters() {
        if (!location.hash) {
            return null;
        }
        let arr = (location.hash || '').split('#')[1].split('&');
        let params = {}
        for (let i = 0; i < arr.length; i++) {
            let data = arr[i].split('=');
            if (data.length === 2) {
                params[data[0]] = data[1]
            }
        }
        return params;
    },
    // 获取Hash参数
    getHashPara(key) {
        let params = this.getHashParameters();
        return params ? params[key] : null;
    },

    changeUrlParams(par, search, value) {
        let pattern = par + '=([^&]*)';
        let replaceText = par + '=' + value;
        if (search.match(pattern)) {
            let tmp = '/\\' + par + '=[^&]*/';
            tmp = search.replace(eval(tmp), replaceText);
            return tmp;
        } else {
            return this.urlAddPara(search, par, value); //如果原来没有这个参数就增加一个
        }
    },

    getGlobalUserId() {
        let cookieGlobalUserId = this.getCookie('globalUserId');
        if (cookieGlobalUserId) {
            cookieGlobalUserId = cookieGlobalUserId.replace(/"/g, ""); //去除双引号
            return cookieGlobalUserId;
        }

        let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                let r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
        uuid = uuid.replace(/-/g, "");
        this.setCookie('globalUserId', uuid);
        return uuid;
    },

    // url添加参数
    urlAddPara(url, name, value) {
        if (!value) {
            return url;
        }
        if (url.indexOf('?') > -1) {
            return url + '&' + name + '=' + value;
        } else {
            return url + '?' + name + '=' + value;
        }
    },
    /**
     * 删除当前url中指定参数
     * @param names 数组或字符串
     * @returns {string}
     */
    urlRemovePara(names) {
        if (typeof (names) == 'string') {
            names = [names];
        }
        let obj = {};
        let arr = window.location.search.substr(1).split("&");
        //获取参数转换为object
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].split("=");
            obj[arr[i][0]] = arr[i][1];
        }
        //删除指定参数
        for (let i = 0; i < names.length; i++) {
            delete obj[names[i]];
        }
        //重新拼接url
        return loca.origin + loca.pathname + "?" + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    },


    isM: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

    isWx: !!navigator.userAgent.match(/MicroMessenger.+?([\d.]+)/i) && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

    isIE: !!window.ActiveXObject || "ActiveXObject" in window,

    baseVerify: {
        isMobile(str) {
            if (str === null || str === "") {
                return false;
            }
            let result = str.match(/^((\(\d{2,3}\))|(\d{3}\-))?(1\d{10})$/);
            if (result === null) {
                return false;
            }
            return true;
        },
        //检查EMAIL
        isEmail(str) {
            // let reg = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
            let reg = /^\S+@\S+$/;
            let flag = reg.test(str);
            return flag;
        },

        //检查邮编
        isZipCode(str) {
            let reg = /^[0-9]{6}$/;
            let flag = reg.test(str);
            return flag;
        },

        //检查数字
        isNum(str) {
            let reg = /^\d+$/;
            let flag = reg.test(str);
            return flag;
        },

        //座机
        isPhone(str) {
            let reg = /^[0-9-()（）#]{2,18}$/;
            let flag = reg.test(str);
            return flag;
        },

        isPassword(str) {
            // let reg = /^[A-Za-z0-9]{6,20}$/;
            // let flag = reg.test(str);
            // return flag;
            return str && str.length >= 6 && str.length <= 20;
        },

        isServiceTag(str) {
            let reg = /^[a-z0-9]{7}$/i;
            let flag = reg.test(str);
            return flag;
        }
    },

    /* 去除空格*/
    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, '');
    },
    /* 深度拷贝*/
    deepClone(data) {
        if (typeof data === 'string') {
            return new String(data.valueOf());
        } else if (typeof data === 'number') {
            return new Number(data.valueOf());
        } else if (typeof data === 'boolean' || typeof data === 'undefined') {
            return data;
        } else if (Array.isArray(data)) {
            let _arr = [];
            data.forEach(item => {
                _arr.push(item);
            });
            return _arr;
        } else if (typeof data === 'object') {
            let _dest = JSON.parse(JSON.stringify(data));
            return _dest;
        }
    },

    // 去登录
    gotoLogin() {
        // this.setLS('loginPath', this.vm.$route.fullPath);

        console.log(this.vm.$route.fullPath);
        this.vm.$router.push({path:'/login', query: { backUrl: this.vm.$route.fullPath }});
    },


    //是否登录
    isLogin() {
        let memberCookie = this.getCookie('smarketMember_498');
        if (memberCookie) {
            var returnObj =  JSON.parse(memberCookie);
            returnObj['OCSESSID'] = this.getCookie('OCSESSID') || '';
            return returnObj;
        } else {
            gio('clearUserId');
            return false;
        }
    },

    // 退出登录
    async logout() {
        this.delCookie('smarketMember_498');
        this.delCookie('OCSESSID');
        this.delLS('userInfo');
        gio('clearUserId');
        await Apis.logout();
        console.log('退出登录')
    },
};
export default tool;
